import React from "react";
import { serviceActions } from "../assets/serviciosDetalle";

export default function ProductionCta({ service }) {
    return (
        <section className="production-cta" id="contacto">
            <div className="production-inner">
                <h2>¿Tenés un <span>evento o proyecto</span> en mente?</h2>
                <p>{service.ctaText}</p>
                <div className="production-cta-actions">
                    <a href={serviceActions.whatsapp}>Contactar por WhatsApp</a>
                    <a href={serviceActions.email}>{serviceActions.emailLabel}</a>
                </div>
            </div>
        </section>
    );
}
